/*  
let fecha = req.body.lista[0].fecha;
let horario = req.body.lista[0].horario;
let tipo = req.body.lista[0].tipo;
let especie = req.body.lista[0].especie;
let cliente = req.body.lista[0].cliente;
*/

async function Agendar(fecha, horario, tipo, especie) {
    
    // Detectar entorno automáticamente
    const BASE_URL = window.location.hostname === "localhost" 
        ? "http://localhost:4000" 
        : "https://vetladradoc.uy";

    try {
        const response = await fetch(`${BASE_URL}/api/consulta/post`, {
            method: "POST",
            // IMPORTANTE: Para que Passport reconozca tu sesión
            credentials: "include", 
            headers: {
                "Content-Type": "application/json"
            },
            // Enviamos solo los datos de la consulta. 
            // El 'cliente' lo saca el backend de req.user
            body: JSON.stringify({
                fecha: fecha,
                horario: horario,
                tipo: tipo,
                especie: especie
            }),
        });

        return response;
    } catch (error) {
        console.error("Error al intentar agendar la consulta:", error);
        throw error;
    }
}

export default Agendar;